import { Calendar } from 'antd';

export default Calendar;